/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var CorpFinFeeEditView = require('../../common/views/CorpFinFeeEditView');
var GetRecord = require('../../common/services/GetRecord');
var GetFee = require('../../common/services/GetFee');
var GetAllRecordLookups = require('../../common/services/GetAllRecordLookups');

module.exports = function(recordId, feeId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetRecord(recordId), GetFee(feeId), GetAllRecordLookups())
    .done(function(record, fee, lookups) {
      NavUtils.navigate('corpfin/exemption/' + recordId + '/fee/' + feeId + '/edit');
      Scaffold.content.show(
        new CorpFinFeeEditView({
          viewMode: 'int',
          model: new Backbone.Model({
            recordId: recordId,
            record: record,
            fee: fee,
            feeTypes: lookups.feeTypes
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
